import React, { useCallback, useEffect, useState } from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Heading,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import FullPageLoader from "../../components/fullPageLoader";
import { getFAQs } from "./services/faqService";

export const Faq = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadFaqs = useCallback(() => {
    setLoading(true);
    getFAQs(setFaqs, setLoading, setError);
  }, []);

  useEffect(() => {
    loadFaqs();
  }, [loadFaqs]);

  const BTN_STYLE = { bg: "#fff", mb: "10px", _focus: { boxShadow: "none" } };
  const REMOVE_BORDER = { border: "none", bg: "#fff", borderRadius: "10px" };

  if (loading) return <FullPageLoader />;

  return (
    <Box p="20px">
      <Heading color="#04332D" fontSize="22px" mb="30px">
        Frequently Asked Questions
      </Heading>
      {error ? (
        <VStack align="flex-start" spacing={3}>
          <Text color="red.500">{error}</Text>
          <Button size="sm" onClick={loadFaqs}>
            Retry
          </Button>
        </VStack>
      ) : faqs.length === 0 ? (
        <Text color="gray.500">No FAQs available yet.</Text>
      ) : (
        <Accordion allowToggle>
          {faqs.map((faq, i) => (
            <AccordionItem key={i} {...REMOVE_BORDER} mb="20px">
              <h2>
                <AccordionButton
                  {...BTN_STYLE}
                  borderBottom="1px solid #f4f4f4"
                >
                  <Stack
                    alignItems="center"
                    direction="row"
                    flex="1"
                    textAlign="left"
                    color="brandColor"
                  >
                    <AiOutlineQuestionCircle size="24px" />
                    <Text fontSize="18px" color="#04332D">
                      {faq?.questionTitle}
                    </Text>
                  </Stack>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} px="20px">
                <Text>{faq?.answer}</Text>
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      )}
    </Box>
  );
};
